import React, { useState, useEffect, useRef } from "react";
import { slides } from "./data";
import "./projects.css";

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const sliderRef = useRef(null);
  const [visibleSlidesCount, setVisibleSlidesCount] = useState(4);

  // Проверяем, нужно ли показывать навигацию
  const showNavigation = slides.length > visibleSlidesCount;

  // Инициализируем видимые слайды
  const [visibleSlides, setVisibleSlides] = useState([]);

  useEffect(() => {
    updateVisibleSlides();
  }, [currentIndex, visibleSlidesCount]);

  const updateVisibleSlides = () => {
    if (slides.length <= visibleSlidesCount) {
      setVisibleSlides(slides);
      return;
    }

    const result = [];
    for (let i = 0; i < visibleSlidesCount; i++) {
      let slideIndex = (currentIndex + i) % slides.length;
      result.push({
        ...slides[slideIndex],
        index: slideIndex,
        position: i,
      });
    }
    setVisibleSlides(result);
  };

  // Общая функция для перехода слайдов
  const changeSlide = (step) => {
    if (!showNavigation || isAnimating) return;

    setIsAnimating(true);

    // Меняем индекс сразу
    setCurrentIndex((prev) => {
      let newIndex = prev + step;
      if (newIndex < 0) return slides.length - 1;
      if (newIndex >= slides.length) return 0;
      return newIndex;
    });

    // Сбрасываем анимацию через время, соответствующее CSS
    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  // Переход к следующему слайду
  const nextSlide = () => changeSlide(1);

  // Переход к предыдущему слайду
  const prevSlide = () => changeSlide(-1);

  // Переход к конкретному слайду
  const goToSlide = (index) => {
    if (!showNavigation || isAnimating || index === currentIndex) return;

    setIsAnimating(true);
    setCurrentIndex(index);

    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  // Автопрокрутка
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    let intervalId;

    if (showNavigation && autoPlay && !isAnimating) {
      intervalId = setInterval(() => {
        nextSlide();
      }, 4000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [showNavigation, autoPlay, isAnimating]);

  // Адаптивность
  useEffect(() => {
    const handleResize = () => {
      setVisibleSlidesCount(window.innerWidth <= 768 ? 3 : 4);
      setVisibleSlidesCount(window.innerWidth <= 480 ? 1 : 4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="projectsBlock"
      ref={sliderRef}
      onMouseEnter={() => setAutoPlay(false)}
      onMouseLeave={() => setAutoPlay(true)}
    >
      <div
        className={`slider-wrapper ${!showNavigation ? "no-navigation" : ""}`}
      >
        <div
          className={`slides-container ${!showNavigation ? "centered" : ""} ${isAnimating ? "animating" : ""}`}
        >
          {visibleSlides.map((slide, localIndex) => {
            const isActive = localIndex === 0;
            const animationDelay = localIndex * 0.05;

            return (
              <div
                className={`slide-card ${isActive ? "active" : ""}`}
                key={`${slide.id}-${slide.index}`}
                style={{
                  animationDelay: `${animationDelay}s`,
                  "--slide-index": localIndex,
                }}
              >
                <div className="slide-image-container">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="slide-image"
                    loading="lazy"
                  />
                </div>
                <div className="slide-content">
                  <span className="slide-hashtag">{slide.hashtag}</span>
                  <h3 className="slide-title">{slide.title}</h3>
                  <p className="slide-description">{slide.description}</p>

                  <div className="slide-footer">
                    <a
                      href={slide.link}
                      className="slide-link"
                      rel="noopener noreferrer"
                    >
                      Подробнее
                    </a>
                  </div>
                </div>
                {/* Эффект свечения для активного слайда */}
                {isActive && <div className="glow-effect"></div>}
              </div>
            );
          })}
        </div>
      </div>

      <div className="slaiderControls">
        {/* Пагинация */}
        {showNavigation && (
          <div className="pagination-wrapper">
            <div className="pagination">
              {slides.map((slide, index) => (
                <button
                  key={slide.id}
                  className={`pagination-dot ${index === currentIndex ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Перейти к слайду ${index + 1}: ${slide.title}`}
                  title={slide.title}
                />
              ))}
            </div>
          </div>
        )}

        {/* Кнопки навигации */}
        {showNavigation && (
          <div className="btnControls">
            <button
              className="slider-button prev"
              onClick={prevSlide}
              aria-label="Предыдущий слайд"
            ></button>
            <button
              className="slider-button next"
              onClick={nextSlide}
              aria-label="Следующий слайд"
            ></button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
